import AboutDevelopers from '../../containers/aboutDevelopers/index'
import AppShell from '../../components/layout/AppShell'

export default function AboutDevelopersPage() {
    return (
        <AppShell title="О разработчиках">
            <AboutDevelopers />
        </AppShell>
    )
}
